import { useMemo } from "react";

import type * as Repository from "../../repository";
import type * as Type from "../type";

type Props = {
	queryData: Repository.Query.Type.MagazineTagQueryData;
	viewModel: Type.ViewModel;
};
type ViewData = Type.ViewData;
type Result = {
	viewData: ViewData;
};

export const useViewDataConverter = ({ queryData, viewModel }: Props): Result => {
	const recommendedTagList = useMemo((): ViewData["recommendedTagList"] => {
		return queryData.magazineTagGetPopularTag.list.map((tag) => tag);
	}, [queryData.magazineTagGetPopularTag.list]);

	const regionWithPrefectureTagList = useMemo((): ViewData["regionWithPrefectureTagList"] => {
		const result = queryData.magazineTagLocationTag.list.map((tag) => ({
			regionTag: tag.tag,
			prefectureTagList: tag.children.map((tag) => tag.tag),
		}));
		return result;
	}, [queryData.magazineTagLocationTag.list]);

	const cityTagList = useMemo((): ViewData["cityTagList"] => {
		return queryData.magazineTagLocationTag.list
			.map((tag) => tag.children)
			.flat()
			.filter((tag) => tag.tag === viewModel.selectedPrefectureTag)
			.map((tag) => tag.children)
			.flat()
			.map((tag) => tag.tag);
	}, [queryData.magazineTagLocationTag.list, viewModel.selectedPrefectureTag]);

	return useMemo(
		() => ({
			viewData: {
				recommendedTagList,
				regionWithPrefectureTagList,
				cityTagList,
			},
		}),
		[cityTagList, recommendedTagList, regionWithPrefectureTagList],
	);
};
